import React from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'
import List from './List'
import SuperadminOfferReview from './SuperadminOfferReview'

const Offers = ({ match }) => (
  <div>
    <Route exact path={match.url} component={List} />
    <Route path={`${match.url}/review/:offerId`} component={SuperadminOfferReview} />
  </div>
)

Offers.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired
  }).isRequired
}

export default Offers
